import $router from "../common/uni-router"
import { Volcengine } from "../common"
export default class WebVolcengine extends Volcengine {
  constructor(params) {
    if (!params) {
      params = {}
    }
    params.type = 1 // 表示是web 端的SDK
    super(params)
    this.routerObject = null
    // web的vue-router 对象，默认为空
    this.isCustomPageviewOpen = false
    this.customPageviewOpenParam = null
    this.afterEachRouter = null
    try {
      this.routerInfo = UNI_ROUTES.pages
      this.tarBar = UNI_ROUTES.tarBar ? UNI_ROUTES.tarBar.list : []
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      // 当H5在PC浏览器运行的时候执行
    } catch (e) {
      this.routerInfo = []
      this.tarBar = []
      if (params.routerObject) {
        const routerObject = params.routerObject
        const currentRouterObject = routerObject.history.current
        this.handelRouterObject(currentRouterObject)
        this.routerObject = routerObject
      }
      // pc执行
    }
  }
  start() {
    this.init(this.routerInfo, this.tarBar)
  }
  // 监听路由的变化 - 只针对H5
  listenRouter(param) {
    let h5Router = null
    try {
      h5Router = UNI_ROUTES
    } catch (e) {}
    if (!h5Router) {
      // PC端
      // 注册全局后置钩子
      if (!this.routerObject) {
        return
      }
      this.routerObject.afterEach((to) => {
        if (this.isCustomPageviewOpen) {
          this.afterGetWebPath(to)
        }
        const routerInfo = {
          path: to.path,
          meta: to.meta,
          query: to.query,
          params: to.params
        }
        this.setCurrentRouterInfo(routerInfo)
        this.reportPageView(param, to)
      })
    } else {
      const isEmptyObject =
        !param || Object.prototype.toString.call(param) !== "[object Object]"
      if (isEmptyObject) {
        param = {}
      }
      $router.onchange = (n) => {
        this.reportPageView(param, n)
      }
    }
  }
  reportPageView(param, n) {
    try {
      const lastVisitUrl = this.getCacheVisitUrl()
      let nowPath = n.fullPath
      if (this.routerObject) {
        nowPath = n.path
      }
      if (lastVisitUrl === nowPath) {
        return
      }
      this.setCacheVisitUrl(nowPath)
      const lastPageVisitTime = this.getCacheTime()
      const nowTime = new Date().getTime()
      this.setCacheTime(nowTime)

      if (!this.volcengineProps[nowPath]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      let commonAttr = this.getCommonAttr(nowPath)
      const durationParam = {
        custom_page_duration: nowTime - lastPageVisitTime
      }
      commonAttr["custom_page_url"] = window.location.href
      if (!commonAttr["custom_page_title"]) {
        const htmlTitle = document.title
        commonAttr["custom_page_title"] = htmlTitle
      }
      if (!commonAttr["custom_page_url_path"]) {
        commonAttr["custom_page_url_path"] = nowPath
      }
      const versionInfo = this.getVersionInfo()
      let webRouterMeta = {}
      if (this.routerObject) {
        const webRouterMetaKeys = Object.keys(n.meta)
        webRouterMetaKeys.forEach((item) => {
          let volcengineFinalKey = item.replace(
            /[A-Z]/g,
            (key) => `_${key.toLowerCase()}`
          )
          webRouterMeta[volcengineFinalKey] = n.meta[item]
        })
      }
      const path = window.location.href
      const sourceObject = this.getFromQueryNameContent(path)
      const finalParam = {
        ...commonAttr,
        ...durationParam,
        ...param,
        ...versionInfo,
        ...sourceObject,
        ...webRouterMeta
      }
      window.collectEvent("custom_pageview", finalParam)
    } catch (e) {
      // console.log(e)
    }
  }
  // 监听初始进入页面
  customPageviewOpen(param) {
    if (this.routerObject) {
      this.customPageviewOpenParam = param
      this.isCustomPageviewOpen = true
      return
    }
    if (!param || Object.prototype.toString.call(param) !== "[object Object]") {
      param = {}
    }
    try {
      let currentUrl
      const pages = this.getCurrentPagesArr()
      this.changeCurrentPage(pages)
      if (this.pages.length > 0) {
        currentUrl = this.pages[0]
      } else {
        //  如果currentPage 为空数组，那就去循环路由数组，是否部分路由是包含于完整路由的
        const routerArr = this.routerInfo
        const nowFullPath = window.location.href
        routerArr.forEach((item) => {
          if (nowFullPath.indexOf(item.path) > -1) {
            currentUrl = "/" + item.path
          }
        })
      }
      // 如果没有任何匹配的，那就是首页
      if (!currentUrl) {
        currentUrl = "/" + this.routerInfo[0].path
      }

      this.setCacheVisitUrl(currentUrl)
      if (!this.volcengineProps[currentUrl]) {
        this.updateRouter(this.routerInfo, this.tarBar)
      }
      let commonAttr = this.getCommonAttr(currentUrl)
      if (!commonAttr["custom_page_title"]) {
        const htmlTitle = document.title
        commonAttr["custom_page_title"] = htmlTitle
      }
      commonAttr["custom_page_url"] = window.location.href
      if (param) {
        commonAttr = {
          ...commonAttr,
          ...param
        }
      }
      window.collectEvent("custom_pageview_open", commonAttr)
      commonAttr.custom_page_duration = 0 // 先默认写死0
      window.collectEvent("custom_pageview", commonAttr)
    } catch (e) {
      console.log("open error", e)
    }
  }

  afterGetWebPath(router) {
    try {
      const meta = router.meta || {}
      const webRouterMetaKeys = Object.keys(meta)
      let webRouterMeta = {}
      webRouterMetaKeys.forEach((item) => {
        let volcengineFinalKey = item.replace(
          /[A-Z]/g,
          (key) => `_${key.toLowerCase()}`
        )
        webRouterMeta[volcengineFinalKey] = meta[item]
      })
      const path = window.location.href
      const sourceObject = this.getFromQueryNameContent(path)

      const title = meta.pageName || document.title
      const data = {
        custom_page_url_path: router.path,
        custom_page_url: window.location.href,
        sub_app_name: meta.subAppName || this.nullProp,
        custom_page_title: title || this.nullProp
      }
      const versionInfo = this.getVersionInfo()

      const commonAttr = {
        ...data,
        ...versionInfo,
        ...webRouterMeta,
        ...sourceObject,
        ...this.customPageviewOpenParam
      }
      this.setCacheVisitUrl(router.path)
      window.collectEvent("custom_pageview_open", commonAttr)
      const pageViewParam = {
        ...commonAttr,
        custom_page_duration: 0
      }
      window.collectEvent("custom_pageview", pageViewParam)
      this.customPageviewOpenParam = null
      this.isCustomPageviewOpen = false
    } catch (e) {}
  }

  afterReportEvent(reportEventName, reportEventParam) {
    try {
      const router = this.getCurrentRouterInfo()
      const meta = router.meta || {}
      const webRouterMetaKeys = Object.keys(meta)
      let webRouterMeta = {}
      webRouterMetaKeys.forEach((item) => {
        let volcengineFinalKey = item.replace(
          /[A-Z]/g,
          (key) => `_${key.toLowerCase()}`
        )
        webRouterMeta[volcengineFinalKey] = meta[item]
      })
      const title = meta.pageName || document.title
      const data = {
        custom_page_url_path: router.path,
        custom_page_url: window.location.href,
        sub_app_name: meta.subAppName || this.nullProp,
        custom_page_title: title || this.nullProp
      }
      const versionInfo = this.getVersionInfo()
      const path = window.location.href
      const sourceObject = this.getFromQueryNameContent(path)

      const commonAttr = {
        ...data,
        ...reportEventParam,
        ...versionInfo,
        ...webRouterMeta,
        ...sourceObject
      }
      window.collectEvent(reportEventName, commonAttr)
    } catch (e) {}
  }
  // 设置用户Id
  setUserUniqueId(paramUserUniqueId) {
    const userUniqueId = paramUserUniqueId || this.nullProp
    try {
      window.collectEvent("config", {
        user_unique_id: userUniqueId
      })
    } catch (e) {}
  }
  // 接口请求上报
  collectApi(param) {
    try {
      const routeInfo = this.getCurrentRouterInfo()
      let currentUrl = this.routerObject ? routeInfo.path : this.pages[0]
      if (!currentUrl) {
        currentUrl = this.getNowPath(this.routerInfo)
      }
      let commonAttr = this.getCommonAttr(currentUrl)

      if (this.routerObject) {
        let webRouterMeta = {}
        const meta = routeInfo.meta || {}
        const title = meta.pageName || document.title
        const routeInfoAttr = {
          custom_page_url_path: routeInfo.path,
          custom_page_url: window.location.href,
          sub_app_name: meta.subAppName || this.nullProp,
          custom_page_title: title || this.nullProp
        }
        const versionInfo = this.getVersionInfo()
        const webRouterMetaKeys = Object.keys(meta)
        webRouterMetaKeys.forEach((item) => {
          let volcengineFinalKey = item.replace(
            /[A-Z]/g,
            (key) => `_${key.toLowerCase()}`
          )
          webRouterMeta[volcengineFinalKey] = meta[item]
        })
        const path = window.location.href
        const sourceObject = this.getFromQueryNameContent(path)
        commonAttr = {
          ...commonAttr,
          ...routeInfoAttr,
          ...versionInfo,
          ...webRouterMeta,
          ...sourceObject
        }
      }
      if (!commonAttr["custom_page_title"]) {
        const htmlTitle = document.title
        commonAttr["custom_page_title"] = htmlTitle
      }
      let apiRequestParam = {
        api_name: param.apiName,
        is_success: param.isSuccess,
        api_time_cost: param.apiTimeCost
      }
      let finalParam = {
        ...commonAttr,
        ...apiRequestParam
      }
      if (!finalParam["custom_page_url"]) {
        finalParam["custom_page_url"] = window.location.href
      }
      delete param.apiName
      delete param.isSuccess
      delete param.apiTimeCost

      finalParam = {
        ...finalParam,
        ...param
      }
      window.collectEvent("api_request", finalParam)
    } catch (e) {}
  }
  reportEvent(name, param) {
    if (this.routerObject) {
      this.afterReportEvent(name, param)
      return
    }
    const pages = this.getCurrentPagesArr()
    this.changeCurrentPage(pages)
    let currentUrl = this.pages[0]
    if (!currentUrl) {
      currentUrl = this.getNowPath(this.routerInfo)
    }
    let commonAttr = this.getCommonAttr(currentUrl)
    if (!commonAttr["custom_page_title"]) {
      const htmlTitle = document.title
      commonAttr["custom_page_title"] = htmlTitle
    }
    let finalParam = {
      ...commonAttr,
      ...param
    }
    if (!finalParam["custom_page_url"]) {
      finalParam["custom_page_url"] = window.location.href
    }
    try {
      window.collectEvent(name, finalParam)
    } catch (e) {}
  }
  profileSet(profileParam) {
    try {
      window.collectEvent("profileSet", profileParam)
    } catch (e) {}
  }

  getSdkVersion() {
    try {
      const versionInfo = this.getVersionInfo()
      return {
        user_analytics_sdk_version_name:
          versionInfo["analytics_sdk_version_name"]
      }
    } catch (e) {
      return {
        user_analytics_sdk_version_name: ""
      }
    }
  }

  getAppVersion() {
    try {
      const versionInfo = this.getVersionInfo()
      return {
        user_custom_app_version_name: versionInfo["custom_app_version_name"]
      }
    } catch (e) {
      return {
        user_custom_app_version_name: ""
      }
    }
  }
  sdkVersionProfileSet(param) {
    try {
      const sdkVersion = this.getSdkVersion()
      const finalParam = {
        ...param,
        ...sdkVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  appVersionProfileSet(param) {
    try {
      const appVersion = this.getAppVersion()
      const finalParam = {
        ...param,
        ...appVersion
      }
      this.profileSet(finalParam)
    } catch (e) {}
  }

  handelRouterObject(routerObject) {
    try {
      const route = routerObject.path
      const meta = routerObject.meta
      const path = route.substring(1, route.length)
      this.routerInfo = [
        {
          path,
          meta
        }
      ]
      this.changeCurrentPage([route])
    } catch (e) {}
  }
}
